import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import { SavedView } from "../../../interfaces/views";
import { getServicesManager } from "../../../services";

export interface SavedViewsState {
  value: SavedView[] | null;
  isEditingModalOpen: boolean;
  editingView: SavedView | null;
}

const savedViewsInitialState: SavedViewsState = {
  value: null,
  isEditingModalOpen: false,
  editingView: null,
};

export const savedViewsSlice = createSlice({
  name: 'savedViews',
  initialState: savedViewsInitialState,
  reducers: {
    updateSavedViews: (state, action: PayloadAction<SavedView[]>) => {
      state.value = action.payload;
    },
    openEditingModal: (state, action: PayloadAction<SavedView | null>) => {
      state.isEditingModalOpen = true;
      state.editingView = action.payload;
    },
    closeEditingModal: (state) => {
      state.isEditingModalOpen = false;
      state.editingView = null;
    },
  }
});

export const { updateSavedViews, openEditingModal, closeEditingModal } = savedViewsSlice.actions;

export function reloadSavedViews(dispatch: Dispatch): Promise<SavedView[] | null> {
  const result = getServicesManager().getSavedViews();
  result.then(v => {
    if (v !== null) {
      dispatch(savedViewsSlice.actions.updateSavedViews(v));
    }
  });
  return result;
} 